import React from 'react'
import EventContent from "../../content/home/needHelp.mdx"
import "./homePanel.scss"; 
import { Column, Row } from 'gatsby-theme-carbon';

 const NeedHelpPanel=() => {
    return (<React.Fragment>
        <div>
            <div className="homePanel">
                <div>
                    <Row >
                        <Column colLg={4} colMd={12} colSm={8}>
                        <h2>Need Help?</h2>
                        </Column>

                    </Row>
                    <EventContent />
                           

                </div>
            </div>
        </div>
    </React.Fragment>
    )
 }
export default NeedHelpPanel;

